export const DASHBOARD = '/';
export const HOME_DASHBOARD = '/home';
export const LOGIN = '/login';
export const LOGIN_CALLBACK = '/login/callback';

export const CAMPAIGN_LIST = '/campaign';
export const CAMPAIGN_CREATE = '/campaign/create';
export const CAMPAIGN_SHOW = '/campaign/:campaignId(\\d+)';
export const CAMPAIGN_EDIT = CAMPAIGN_SHOW + '/edit';
export const CAMPAIGN_CODES_ASSIGN = CAMPAIGN_SHOW + '/codes-assign/';

export const ORDER_LIST = '/orders';

export const CLIENT_LIST = '/client';
export const CLIENT_CREATE = '/client/create';
export const CLIENT_SHOW = '/client/:clientId(\\d+)';
export const CLIENT_EDIT = '/client/:clientId(\\d+)/edit';

export const PROPOSAL_LIST = '/proposal/';
export const PROPOSAL_SHOW = '/proposal/:proposalId(\\d+)';
export const PROPOSAL_EDIT = PROPOSAL_SHOW + '/edit/';
export const PROPOSAL_NEGOTIATION = PROPOSAL_SHOW + '/negotiation/';
export const PROPOSAL_CREATE = CAMPAIGN_SHOW + '/proposal/create/';
export const PROPOSAL_CREATE_FROM_CAMPAIGN =
  CAMPAIGN_SHOW + '/proposal/create/:category(\\d+)?';
export const PROPOSAL_COMMITTED =
  '/proposal/:committedProposalId(\\d+)/committed/';
export const PROPOSAL_PRODUCT_COUNTEROFFER = PROPOSAL_SHOW + '/counteroffer/';
export const PROPOSAL_PRODUCT_COUNTEROFFER_CAT =
  PROPOSAL_SHOW + '/counteroffer/:category(\\d+)?';

export const FLIGHT_EDIT = PROPOSAL_SHOW + '/flight/:flightId/edit';
export const FLIGHT_CREATE = PROPOSAL_SHOW + '/flight/create';

export const PRODUCT_LIST = '/product';
export const PRODUCT_CREATE = '/product/create';
export const PRODUCT_SHOW = '/product/:productId(\\d+)';
export const PRODUCT_EDIT = PRODUCT_SHOW + '/edit';

export const MARKET_LIST = '/market/';
export const MARKET_SHOW = '/market/:category(\\d+)?';

export const USER_LIST = '/user';
export const USER_SETTINGS = '/user/settings';
/* export const USER_CREATE = '/user/create';
export const USER_SHOW = '/user/:userId(\\d+)';
export const USER_EDIT = '/user/:userId(\\d+)/edit'; */

export const AD_SLOT_LIST = '/adslot';
export const AD_SLOT_CREATE = '/adslot/create';
export const AD_SLOT_SHOW = '/adslot/:adSlotId(\\d+)';
export const AD_SLOT_EDIT = '/adslot/:adSlotId(\\d+)/edit';

export const AD_FORMAT_LIST = '/adformat';
export const AD_FORMAT_CREATE = '/adformat/create';
export const AD_FORMAT_SHOW = '/adformat/:adFormatId(\\d+)';
export const AD_FORMAT_EDIT = '/adformat/:adFormatId(\\d+)/edit';

export const AD_TYPE_LIST = '/adtype';

export const TRADING_LIST = '/trading';

export const CLIENT_MANAGER_LIST = '/client/manager';
export const CLIENT_MANAGER_CREATE = '/client/manager/create';
export const CLIENT_MANAGER_SHOW = '/client/manager/:clientManagerId(\\d+)';
export const CLIENT_MANAGER_EDIT =
  '/client/manager/:clientManagerId(\\d+)/edit';
